// Team member flip functionality
export function team() {
  // Flip on click for mobile devices
  document.querySelectorAll('.empower-block__team-member.enable-flip .image .flip-container').forEach((container) => {
    container.addEventListener('click', () => {
      const flipper = container.querySelector('.flipper');
      flipper.classList.toggle('flipped');
    });
  });
}
